import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { DroneSource } from './drone-source.model';

/**
 * A document attached to a drone for record-keeping or maintenance history, built from the hub's
 * `/admin/drones/:droneId/resources` JSON (hub `data-models/drone-resource.ts`). `droneId` is polymorphic:
 * `droneSource` says whether it points at an ADN drone or an organization-owned one.
 *
 * Fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class DroneResource extends Base {
  // Set on upload, changeable through PATCH
  resourceType?: string | null;
  caption?: string | null;
  /** TRUE = ADN staff only. */
  adminOnly?: boolean | null;
  fileName?: string | null;
  fileSize?: number | null;
  fileType?: string | null;
  fileExtension?: string | null;
  s3Key?: string | null;
  /** Not directly loadable (resources are private): open one through its signed download URL. */
  cdnUrl?: string | null;

  // Read-only
  droneId?: string | null;
  droneSource?: DroneSource | null;
  uploadedByProfileId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.resourceType = nullableString(source['resourceType']);
    this.caption = nullableString(source['caption']);
    this.adminOnly = nullableBoolean(source['adminOnly']);
    this.fileName = nullableString(source['fileName']);
    this.fileSize = nullableNumber(source['fileSize']);
    this.fileType = nullableString(source['fileType']);
    this.fileExtension = nullableString(source['fileExtension']);
    this.s3Key = nullableString(source['s3Key']);
    this.cdnUrl = nullableString(source['cdnUrl']);
    this.droneId = nullableString(source['droneId']);
    this.droneSource = nullableString(source['droneSource']) as DroneSource | null | undefined;
    this.uploadedByProfileId = nullableString(source['uploadedByProfileId']);
  }
}
